import React from "react";
import moment from "moment";

import { fetchApi } from "../../Network/NetworkService";
import { notif } from "../Ui/Notification";

import "../../Assets/Pages/dermatoSdr.css";
import IconTooltip from "../Ui/IconTooltip";

// Patients qui ont cliqué sur au moins un bouton de l'email de parrainage
// (Instagram / TikTok / WhatsApp), campagne manuelle et envois automatiques
// confondus. Alimenté par la redirection traçante /referral-campaign/click ;
// « Filleuls » vient du système de parrainage de feeli-server (collection
// referrals, lecture seule).
const TARGET_META = {
  whatsapp: { label: "WhatsApp", color: "#1da851" },
  instagram: { label: "Instagram", color: "#dd2a7b" },
  tiktok: { label: "TikTok", color: "#010101" },
};

class ReferralClicks extends React.Component {
  constructor() {
    super();
    this.state = {
      users: [],
      loading: false,
      loaded: false,
      page: 1,
      totalPage: 0,
      countUsers: 0,
      invitedCount: 0,
    };
  }

  componentDidMount() {
    this.fetchClicks();
  }

  fetchClicks = () => {
    this.setState({ loading: true });
    fetchApi("/referral-campaign/clicks?page=" + this.state.page)
      .then((res) => {
        this.setState({
          users: res.users || [],
          totalPage: res.countPages || 0,
          countUsers: res.countUsers || 0,
          invitedCount: res.invitedCount || 0,
          loaded: true,
          loading: false,
        });
      })
      .catch(() => {
        notif.addNotification(
          "Erreur",
          "Erreur de récupération des clics",
          "warning",
        );
        this.setState({ loading: false });
      });
  };

  updatePage(page) {
    this.setState({ users: [], page, loading: true }, this.fetchClicks);
  }

  renderTargets(targets) {
    const list = (targets || []).slice().sort((a, b) => b.count - a.count);
    return list.map((t) => {
      const meta = TARGET_META[t.target] || { label: t.target, color: "#888" };
      return (
        <span
          key={t.target}
          style={{
            display: "inline-block",
            background: meta.color,
            color: "#fff",
            borderRadius: 12,
            padding: "2px 10px",
            fontSize: 12,
            marginRight: 6,
            whiteSpace: "nowrap",
          }}
        >
          {meta.label}
          {t.count > 1 ? " ×" + t.count : ""}
        </span>
      );
    });
  }

  render() {
    const {
      users,
      loading,
      loaded,
      page,
      totalPage,
      countUsers,
      invitedCount,
    } = this.state;
    const rate =
      invitedCount > 0 ? Math.round((countUsers / invitedCount) * 100) : 0;

    return (
      <div className="dermato-sdr-container">
        <div className="dermato-sdr-header">
          <h2 className="dermato-sdr-title">
            {"Suivi des clics — Parrainage"}
          </h2>
          <button
            className="dermato-sdr-btn dermatosdr-btn-link"
            onClick={() => this.props.history.push("/campagne-parrainage")}
          >
            {"← Retour à la campagne"}
          </button>
        </div>

        <div className="dermato-sdr-card">
          <h3 className="dermato-sdr-card-title">
            {"Patients ayant cliqué dans l'email"} ({countUsers})
          </h3>
          <p style={{ color: "#888", fontSize: 14, marginTop: -8 }}>
            {invitedCount} {"emails de parrainage envoyés → "}
            <strong style={{ color: "#2e7d32" }}>
              {countUsers} {"patients ont cliqué"}
            </strong>
            {" ("}
            {rate}
            {" %). Chaque clic sur un bouton (Instagram, TikTok, WhatsApp) est compté ; les filtres de sécurité de certaines boîtes mail suivent parfois les liens à la réception, ces compteurs sont donc un plafond. « Filleuls » : inscriptions via le lien personnel du patient, dont celles arrivées jusqu'à une première consultation."}
          </p>

          {loading ? (
            <div className="dermato-sdr-empty">
              <span className="loader" />
            </div>
          ) : loaded && users.length === 0 ? (
            <div className="dermato-sdr-empty">
              {"Aucun clic enregistré pour le moment."}
            </div>
          ) : users.length > 0 ? (
            <div>
              <table className="dermato-sdr-table">
                <thead>
                  <tr>
                    <th>Nom</th>
                    <th>Email</th>
                    <th>{"Email envoyé le"}</th>
                    <th>{"Boutons cliqués"}</th>
                    <th>{"Dernier clic"}</th>
                    <th>{"Filleuls"}</th>
                  </tr>
                </thead>
                <tbody>
                  {users.map((u) => (
                    <tr key={u._id}>
                      <td>
                        {u.FName} {u.LName}
                      </td>
                      <td>{u.email || "—"}</td>
                      <td>
                        {u.referralEmailSentAt
                          ? moment(u.referralEmailSentAt).format(
                              "DD/MM/YYYY HH:mm",
                            )
                          : u.campaignDate || "—"}
                      </td>
                      <td>{this.renderTargets(u.targets)}</td>
                      <td style={{ color: "#2e7d32", fontWeight: 600 }}>
                        {u.lastClickAt
                          ? moment(u.lastClickAt).format("DD/MM/YYYY HH:mm")
                          : "—"}
                      </td>
                      <td>
                        {u.signups > 0 ? (
                          <span>
                            <strong>{u.signups}</strong>
                            {" inscrit" + (u.signups > 1 ? "s" : "")}
                            {u.converted > 0
                              ? ", " +
                                u.converted +
                                " avec consultation"
                              : ""}
                          </span>
                        ) : (
                          "—"
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="dermatosdr-pagination">
                <p style={{ margin: 0, color: "#888", fontSize: 14 }}>
                  Page <strong>{page}</strong> / {totalPage}
                </p>
                <div>
                  {page > 1 && (
                    <IconTooltip
                      icon="fa fa-chevron-left"
                      text="Page précédente"
                      onClick={() => this.updatePage(page - 1)}
                    />
                  )}
                  {page < totalPage && (
                    <IconTooltip
                      icon="fa fa-chevron-right"
                      text="Page suivante"
                      onClick={() => this.updatePage(page + 1)}
                    />
                  )}
                </div>
              </div>
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}

export default ReferralClicks;
